module.exports = __webpack_public_path__ + "static/img/tailwind.b905b2ca.svg";